export default {"src":"/_next/static/media/Hyperpigmentation.8dbc8ea1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};